import { CalendarServiceProvider } from './services/calendar-service/calendar-service';
import { EventEntryComponent } from './components/event-entry/event-entry.component';
import { EventsDataSource } from './services/events-data-source/events-data-source.class';
import { EventsServiceProvider } from './services/events-service/events-service';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [EventEntryComponent],
  providers: [CalendarServiceProvider, EventsServiceProvider, { provide: 'EventsDataSource', useClass: EventsDataSource }],
  entryComponents: [EventEntryComponent],
})
export class SellionsCalendarModule {}



// WEBPACK FOOTER //
// ./src/modules/calendar/calendar.module.ts